import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/fee-pay-list/feepaylist/payListPage', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/fee-pay-list/feepaylist/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/fee-pay-list/feepaylist/remove?id=' + params, Object.assign({}, options, {}));

export const add = (params, options) =>
  request.post('/api/fee-pay-list/feepaylist/submit', params, options);

export const update = (params, options) =>
  request.post('/api/fee-pay-list/feepaylist/submit', params, options);

export const getExcel = (params, options) =>
  request.get('/api/fee-pay-list/feepaylist/payListExcel', Object.assign({}, options, { params }));

export const payPageTree = (params, options) =>
  request.get('/api/fee-pay-list/feepaylist/payPageTree', Object.assign({}, options, { params }));

export const payErrorPageTree = (params, options) =>
  request.get('/api/fee-pay-list/feepaylist/error/payPageTree', Object.assign({}, options, { params }));

export const payQuery = (params, options) =>
  request.get('/api/fee-pay-list/feepaylist/error/pay/query', Object.assign({}, options, { params }));

export const payQueryV1 = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/querychannel', Object.assign({}, options, { params }));

export const payPageChildren = (params, options) =>
  request.get(
    '/api/fee-pay-list/feepaylist/payPageChildren?id=' + params,
    Object.assign({}, options, {})
  );

export const getTreeExcel = (params, options) =>
  request.get(
    '/api/fee-pay-list/feepaylist/payListTreeExcel',
    Object.assign({}, options, { params })
  );

export const paySummarize = (params, options) =>
  request.get('/api/fee-pay-list/feepaylist/paySummarize', Object.assign({}, options, { params }));

export const paySummarizeExcel = (params, options) =>
  request.get(
    '/api/fee-pay-list/feepaylist/paySummarizeExcel',
    Object.assign({}, options, { params })
  );

export const beforeOpenApply = (feeId) => {
  return request({
    url: '/api/feeBack/feereturn/openApplyForm',
    method: 'get',
    params: {
      feeId,
    },
  });
};

export const getInvoicePrintJournalList = (params, options) =>
  request.get('/api/v4ward/fee_pay_invoice_print_journal/page', Object.assign({}, options, { params }));



export const feeSortListByCommunityId = (params, options) =>
request.get('/api/fee/itemset/sortTypeListByCommunityId', Object.assign({}, options, { params }));


//缴费详情分页
export const payListPage = (params, options) =>
request.get('/api/fee-pay-list/feepaylist/payListPage', Object.assign({}, options, { params }));

//获取使用性质
export const getUseTypes = () => request.get('/api/base/property/getUseTypes?code=use_type&remark=0');

//缴费详情分页
export const payListPageByFeePayId = (params, options) =>
  request.get('/api/fee-pay-list/feepaylist/payListPageByFeePayId', Object.assign({}, options, { params }));

  //缴费详情分页
export const getUseTypeListByCommunityId = (params, options) =>
request.get('/api/base/property/getUseTypeListByCommunityId', Object.assign({}, options, { params }));
export const getSortTypeByCommunityId = (params, options) =>
request.get('/api/fee-pay-list/feepaylist/getSortTypeByCommunityId', Object.assign({}, options, { params }));

export const getAllRoomByCommunityId = (params, options) =>
request.get('/api/base/property/getAllRoomByCommunityId', Object.assign({}, options, { params }));